import { EDIT_TYPES, TRAIN_TYPES } from '../../config';
import Colors from '../../styles/Colors';

export interface StatsCountProps {
  field: 'train_type' | 'edit_type' | string;
  fieldValue?: string;
  name?: string;
  count?: number;
}

const TRAIN_COLOR: Record<string, string> = {
  [TRAIN_TYPES.EMPTY]: Colors.trainTypeUnchanged,
  [TRAIN_TYPES.POINT]: Colors.trainTypePoint,
  [TRAIN_TYPES.FSI]: Colors.trainTypeFSI,
  [TRAIN_TYPES.FPI]: Colors.trainTypeFPI,
  [TRAIN_TYPES.FSD]: Colors.trainTypeFSD,
  [TRAIN_TYPES.FPD]: Colors.trainTypeFPD,
  [TRAIN_TYPES.NSGL]: Colors.trainTypeNSGL,
  [TRAIN_TYPES.NSF]: Colors.trainTypeNSF,
  [TRAIN_TYPES.NST]: Colors.trainTypeNST,
};

const EDIT_COLOR: Record<string, string> = {
  [EDIT_TYPES.ACCEPT]: Colors.editTypeAccept,
  [EDIT_TYPES.REVISE]: Colors.editTypeRevise,
  [EDIT_TYPES.REJECT]: Colors.editTypeReject,
};

const getColor = (field: string, fieldValue?: string): string => {
  if (field === 'train_type') {
    return TRAIN_COLOR[fieldValue ?? ''] ?? TRAIN_TYPES.EMPTY;
  }
  if (field === 'edit_type') {
    return EDIT_COLOR[fieldValue ?? ''] ?? '#DFE8FE';
  }
  return '#DFE8FE';
};

const StatsCount = ({ field, fieldValue, count }: StatsCountProps) => (
  <span
    style={{
      display: 'inline-block',
      backgroundColor: getColor(field, fieldValue),
      color: '#5C6E81',
      padding: '0 8px',
      whiteSpace: 'nowrap',
      fontWeight: 'bold',
    }}
  >
    {count} {fieldValue || 'no changes'}
  </span>
);

export default StatsCount;
